import { Component, OnInit } from '@angular/core';
import { CurrentPortfolio } from 'src/app/models/current-portfolio.model';
import { Subscription } from 'rxjs';
import { ClustersService } from 'src/app/services/clusters.service';
import { PositionKeepingAnalysis } from 'src/app/models/analysis/position-keeping-analysis.model';
import { TableUtil } from 'src/app/utils';

@Component({
  selector: 'app-position-keeping-protection',
  templateUrl: './position-keeping-protection.component.html',
  styleUrls: ['./position-keeping-protection.component.scss']
})
export class PositionKeepingProtectionComponent implements OnInit {

  inceptionDate: Date;
  investmentDate: Date;
  lastDate: Date;

  currentInvestable: CurrentPortfolio;
  currentInvestableSubscription: Subscription;

  selectedTurnoverTab: string ='Turnover';

  investablePKA: PositionKeepingAnalysis;
  investablePA;
  is_standalone: boolean = false;
  is_protected: boolean = true;

  monthly_dates: string[];

  constructor(private clustersService: ClustersService) { }

  ngOnInit(): void {
    this.subscribeToCurrentInvestable();
  }

  ngOnDestroy() {
    if(this.currentInvestableSubscription!=undefined) { this.currentInvestableSubscription.unsubscribe(); }
  }

  subscribeToCurrentInvestable() {
    this.currentInvestableSubscription = this.clustersService.currentInvestableSubject.subscribe(
      (investable_portfolio: CurrentPortfolio) => {
        if (investable_portfolio!=undefined) {
          this.inceptionDate = investable_portfolio.positionKeepingAnalysis.inception_date;
          this.investmentDate = investable_portfolio.positionKeepingAnalysis.investment_date;
          this.lastDate = investable_portfolio.positionKeepingAnalysis.last_date;
          this.investablePKA = investable_portfolio.positionKeepingAnalysis;
          this.monthly_dates = Object.keys(this.investablePKA.protection.monthly_returns.investable);
          this.investablePA = this.investablePKA.protection;
          this.is_standalone = this.investablePA.monthly_returns.original ? false : true;
        }
      }
    );
    this.clustersService.emitCurrentInvestable();
  }

  exportTable(){
    TableUtil.exportToExcel("tableToExport");
  }

}
